import { Button, type ButtonProps, Text, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { FiEye } from "react-icons/fi";
import { RootState } from "../../app/mainReducer";
import { PdfVisualizacaoModal } from "../../../components";
import { apiCall } from "../../../utils/apiCall";
import { formatAxiosErrorMessage } from "../../../utils/formatError";

export interface VerAgendamentoButtonProps {
  j14_ukey: string;
  j07_ukey: string;
  pedido_numero: string;
  pedido_status_agendamento: string;
  mt?: ButtonProps["mt"];
  ml?: ButtonProps["ml"];
}

const VerAgendamentoButton = ({
  j14_ukey,
  j07_ukey,
  pedido_numero,
  pedido_status_agendamento,
  mt,
  ml,
}: VerAgendamentoButtonProps) => {
  const networkOnline = useSelector((state: RootState) => state.login.networkOnline || false);
  const toast = useToast();
  const [agendamentoLoading, setAgendamentoLoading] = useState(false);
  const [agendamentoModalOpen, setAgendamentoModalOpen] = useState(false);
  const [agendamentoPdfBlob, setAgendamentoPdfBlob] = useState<Blob | null>(null);

  const fecharAgendamento = () => {
    setAgendamentoPdfBlob(null);
    setAgendamentoModalOpen(false);
  };

  const verAgendamento = async () => {
    if (!networkOnline) {
      toast({
        title: "Sem internet",
        description: "Não é possível abrir o agendamento sem conexão. Conecte-se à internet e tente de novo.",
        status: "warning",
        duration: 6000,
        isClosable: true,
      });
      return;
    }
    setAgendamentoLoading(true);
    try {
      const { data } = await apiCall({
        method: "post",
        url: `/gestao-de-entrega/v2/cargas/${j14_ukey}/imprime-agendamento/${j07_ukey}`,
        responseType: "blob",
      });
      setAgendamentoPdfBlob(data as Blob);
      setAgendamentoModalOpen(true);
    } catch (error) {
      const description = await formatAxiosErrorMessage(error);
      toast({
        title: "Erro ao imprimir agendamento",
        description,
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setAgendamentoLoading(false);
    }
  };

  if (!(pedido_status_agendamento == "1")) {
    return null;
  }

  const tituloAgendamento = `Agendamento — Pedido ${pedido_numero}`;
  const nomeArquivoAgendamento = `Agendamento_pedido_${pedido_numero.replace(/[^a-zA-Z0-9._-]/g, "_")}.pdf`;

  return (
    <>
      <Button mt={mt} ml={ml} onClick={verAgendamento} size="sm" colorScheme="yellow" isLoading={agendamentoLoading}>
        <FiEye fontSize="1.3em" /> <Text ml={1}>VER AGENDAMENTO</Text>
      </Button>
      <PdfVisualizacaoModal
        isOpen={agendamentoModalOpen}
        onClose={fecharAgendamento}
        pdfBlob={agendamentoPdfBlob}
        nomeArquivoSugerido={nomeArquivoAgendamento}
        titulo={tituloAgendamento}
        tituloIframe={`Agendamento pedido ${pedido_numero}`}
      />
    </>
  );
};

export default VerAgendamentoButton;
